import React from 'react';
import { Flex } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { PolicyProvider } from '@Policy/store';
import { getExchangeTemplateConfig } from '@Policy/TemplateConfig/cfg.exchange';
import { LocalAccountTargets } from '../../../../RoleTargets/LocalAccoutTargets';
import { RoleTarget } from '@Types/administrator';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';

const AddRoleAssigment = ({
  currentOrgId,
  setCheckTargets,
}: {
  currentOrgId: string;
  setCheckTargets: (checkedKeys: RoleTarget[]) => void;
}) => {
  const { t } = useTranslation();
  const configData: any = {};
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  const defaultTemplate = getExchangeTemplateConfig(
    t,
    selectedOrgGlobalSetting,
    ''
  );
  return (
    <PolicyProvider
      template={defaultTemplate}
      config={configData}
      key={currentOrgId}
      orgId={currentOrgId}
    >
      <Flex mt="23px" alignItems="flex-start">
        <LocalAccountTargets setCheckTargets={setCheckTargets} />
      </Flex>
    </PolicyProvider>
  );
};

export default React.memo(AddRoleAssigment);
